import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

/* Heavily influenced by Josh Comeau's CSS Reset: https://www.joshwcomeau.com/css/custom-css-reset/ */
export const globalStyles = css`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  * {
    margin: 0;
  }

  body {
    background-color: ${theme.colors.neutral5};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  img,
  picture,
  video,
  canvas,
  svg {
    display: block;
    max-width: 100%;
  }

  input,
  button,
  textarea,
  select {
    font: inherit;
  }

  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    overflow-wrap: break-word;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  p {
    color: ${theme.colors.text.subdued};
  }

  #root {
    position: relative;
  }
`;
